const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-staffers",
  },
  actions: {
    updateMenus({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-menus`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
